let globalTransaction = null;
let globalInstallment = null;
let globalCnpj = null;
let globalOriginalDueDate = null;
let globalInvoiceNumber = null;


async function searchInvoices(type) {
  const input = document.getElementById(`search-${type}`);
  const container = document.getElementById(`tab-${type}-content`);
  const header = document.getElementById(`header-${type}`);
  const cnpj = document.getElementById(`search-${type}-cnpj`).value;

  const invoiceNumber = input.value.trim();
  if (!invoiceNumber) return alert("Digite a Nota Fiscal");

  container.innerHTML = "<p style='padding-top:30px'>Buscando...</p>";
  header.classList.remove("active");

  const productType = "LIGHTERA_CARD";

  try {
    const token = await login();
    const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/billing?cnpj=${cnpj}&invoiceNumber=${invoiceNumber}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "X-Operator-ID": "frontend shopify",
      }
    });

    if (response.status === 401) {
      container.innerHTML = "<p style='padding-top:30px'>Sessão expirada. Recarregue a página.</p>";
      return;
    }

    if (response.status === 404) {
      container.innerHTML = "<p style='padding-top:30px'>Nota Fiscal não encontrada.</p>";
      return;
    }

    if (!response.ok) {
      container.innerHTML = "<p style='padding-top:30px'>Erro ao buscar Nota Fiscal. Tente novamente.</p>";
      return;
    }

    const data = await response.json();

    if (data.noPendingInvoice) {
      container.innerHTML = "<p style='padding-top:30px'>Nota Fiscal encontrada, porém não há pendências em aberto.</p>";
      return;
    }

    if (!data.installments || !data.installments.length) {
      container.innerHTML = "<p style='padding-top:30px'>Nenhuma parcela encontrada para esta Nota Fiscal.</p>";
      return;
    }

    header.classList.add("active");
    globalInvoiceNumber = invoiceNumber;
    renderInvoicesData(data.installments, container, productType, data.transactionId, cnpj);

  } catch (err) {
    console.error(err);
    container.innerHTML = "<p style='padding-top:30px'>Erro ao buscar NF.</p>";
  }
}

const STATUS_PAGO    = ['2', '6'];
const STATUS_INATIVO = ['3', '4', '7'];

function renderInvoicesData(installments, container, productType, transactionId, cnpj) {
  container.innerHTML = installments.map(inst => {
    const due = new Date(inst.dueDate + "T00:00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const daysOverdue = Math.floor((today - due) / 86400000);
    const status = String(inst.status);

    let btn = "";

    if (STATUS_PAGO.includes(status)) {
      btn = `<span class="invoice-status-label pago">Pago</span>`;
    } else if (STATUS_INATIVO.includes(status)) {
      btn = `<span class="invoice-status-label inativo">Inativo</span>`;

    } else if (status === '0') {
      btn = `<button class="invoice-btn" onclick="downloadBoleto('${transactionId}', ${inst.installment}, '${cnpj}')">Baixar</button>`;

    } else if (status === '1') {

      if (daysOverdue === 0) {
        btn = `<button class="invoice-btn" onclick="downloadBoleto('${transactionId}', ${inst.installment}, '${cnpj}')">Baixar</button>`;
      }

      else {
        if (daysOverdue <= 30) {
          btn = `<div class="invoice-btn-wrapper"><button class="invoice-btn invoice-btn--expired" onclick="showRenewalUnavailableModal()">Vencido</button><span id="renewal-msg-${inst.installment}" class="renewal-msg"></span></div>`;
        } else if (daysOverdue === 31) {
          btn = `<button class="invoice-btn" onclick="downloadBoleto('${transactionId}', ${inst.installment}, '${cnpj}')">Emitir Hoje</button>`;
        } else {
          btn = `<button class="invoice-btn invoice-btn--expired" onclick="showCardBlockedModal()">Vencido</button>`;
        }
      }

    }

    return `
      <div class="parcela-block">
        <div class="boleto block-info">
          <p>${inst.installment}</p>
          <p>${inst.dueDate.split('-').reverse().join('/')}</p>
          <p>${Number(inst.amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
          ${btn}
        </div>
      </div>
    `;
  }).join("");
}

async function downloadBoleto(transactionId, installment, cnpj) {
  try {
    const token = await login();
    const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/supplier-boleto?transactionId=${transactionId}&installment=${installment}&cnpj=${cnpj}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "X-Operator-ID": "frontend shopify",
      }
    });

    if (!response.ok) {
      showErrorModal("Erro ao gerar boleto. Tente novamente.");
      return;
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = `boleto_parcela_${installment}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);

  } catch (err) {
    console.error("Erro ao baixar boleto:", err);
    showErrorModal("Erro ao gerar boleto. Tente novamente.");
  }
}

function openDateModal(transactionId, installment, cnpj, dueDate) {
  globalTransaction = transactionId;
  globalInstallment = installment;
  globalCnpj = cnpj;
  globalOriginalDueDate = new Date(dueDate + "T00:00:00");

  const dateInput = document.getElementById("new-due-date");
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  const minDate = addBusinessDays(today, 3);
  dateInput.min = minDate.toISOString().split("T")[0];

  const maxDate = new Date(globalOriginalDueDate);
  maxDate.setDate(maxDate.getDate() + 30);
  dateInput.max = maxDate.toISOString().split("T")[0];

  dateInput.oninput = null;

  document.getElementById("date-modal").style.display = "flex";
}

function closeDateModal() {
  document.getElementById("date-modal").style.display = "none";
  const modalSuccess = document.getElementById("date-modal-success");
  const btnConfirm = document.getElementById("btn-modal-confirm");
  const btnCancel = document.querySelector("#date-modal .btn-cancel");
  const btnClose = document.getElementById("btn-modal-close");
  if (modalSuccess) modalSuccess.style.display = "none";
  if (btnConfirm) btnConfirm.style.display = "";
  if (btnCancel) btnCancel.style.display = "";
  if (btnClose) btnClose.style.display = "none";
}

let renewalRunning = false;

async function confirmNewDate() {
  if (renewalRunning) return;

  const date = document.getElementById("new-due-date").value;
  if (!date) return showErrorModal("Escolha uma data", "Atenção");

  const chosen = new Date(date + "T00:00:00");
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffDays = Math.ceil((chosen - today) / 86400000);

  renewalRunning = true;

  const token = await login();

  const response = await fetch(`${baseUrl}/shopify-order-connector/v1/shopify-order-connector/boleto-renewal`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-Operator-ID": "frontend shopify",
    },
    body: JSON.stringify({
      cnpjCpf: globalCnpj,
      codigoTransacao: globalTransaction,
      numeroNotaFiscal: globalInvoiceNumber,
      numeroParcela: globalInstallment,
      numeroDiasProrrogacao: diffDays,
      novaDataVencimento: date,
    })
  });

  if (!response.ok) {
    let msg = "Não foi possível realizar a prorrogação. Tente novamente.";
    if (response.status === 409) {
      msg = "Esta parcela já possui uma prorrogação solicitada.";
    } else {
      try {
        const errData = await response.json();
        if (errData.mensagemRetorno && !/\d/.test(errData.mensagemRetorno)) msg = errData.mensagemRetorno;
        else if (errData.mensagemErro && !/\d/.test(errData.mensagemErro)) msg = errData.mensagemErro;
      } catch (_) {}
    }
    const msgElErr = document.getElementById(`renewal-msg-${globalInstallment}`);
    if (msgElErr) {
      msgElErr.textContent = msg;
      msgElErr.className = "renewal-msg renewal-msg--error";
    }
    renewalRunning = false;
    closeDateModal();
    return;
  }

  const modalSuccess = document.getElementById("date-modal-success");
  const btnConfirm = document.getElementById("btn-modal-confirm");
  const btnCancel = document.querySelector("#date-modal .btn-cancel");
  const btnClose = document.getElementById("btn-modal-close");
  if (modalSuccess) modalSuccess.style.display = "block";
  if (btnConfirm) btnConfirm.style.display = "none";
  if (btnCancel) btnCancel.style.display = "none";
  if (btnClose) btnClose.style.display = "";

  const btn = document.getElementById(`btn-prorrogar-${globalInstallment}`);
  if (btn) {
    btn.disabled = true;
    btn.classList.add("invoice-btn--disabled");
  }
  const msgEl = document.getElementById(`renewal-msg-${globalInstallment}`);
  if (msgEl) {
    msgEl.textContent = "Solicitado!";
    msgEl.className = "renewal-msg renewal-msg--success";
  }
  renewalRunning = false;
}


function showErrorModal(message, title = "Erro") {
  document.getElementById("error-modal-title").textContent = title;
  document.getElementById("error-modal-message").textContent = message;
  document.getElementById("error-modal").style.display = "flex";
}

function closeErrorModal() {
  document.getElementById("error-modal").style.display = "none";
}

function showRenewalUnavailableModal() {
  document.getElementById("renewal-unavailable-modal").style.display = "flex";
}

function closeRenewalUnavailableModal() {
  document.getElementById("renewal-unavailable-modal").style.display = "none";
}

function showCardBlockedModal() {
  document.getElementById("card-blocked-modal").style.display = "flex";
}

function closeCardBlockedModal() {
  document.getElementById("card-blocked-modal").style.display = "none";
}

function openTabBoleto(event, tab) {
  const tabs = document.querySelectorAll('.tab-main');
  const titleTabs = document.querySelectorAll('.orcamento-tab');

  tabs.forEach((t) => t.classList.remove('active'));
  titleTabs.forEach((t) => t.classList.remove('active'));

  event.srcElement.classList.add('active');
  document.querySelector('#' + tab).classList.add('active');

  resetInvoiceSearch(tab);
}

function resetInvoiceSearch(tab) {
  const modal = document.getElementById("date-modal");
  if (modal) modal.style.display = "none";

  if (tab === "tab-card") {
    const input = document.getElementById("search-card");
    const content = document.getElementById("tab-card-content");
    const header = document.getElementById("header-card");

    if (input) input.value = "";
    if (content) content.innerHTML = "";
    if (header) header.classList.remove("active");
  }

  if (tab === "tab-flex") {
    const input = document.getElementById("search-flex");
    const content = document.getElementById("tab-flex-content");
    const header = document.getElementById("header-flex");

    if (input) input.value = "";
    if (content) content.innerHTML = "";
    if (header) header.classList.remove("active");
  }
}